import { render, staticRenderFns } from "./DropdownToggle.vue?vue&type=template&id=5cc25de7&scoped=true&"
import script from "./DropdownToggle.vue?vue&type=script&lang=js&"
export * from "./DropdownToggle.vue?vue&type=script&lang=js&"
import style0 from "./DropdownToggle.vue?vue&type=style&index=0&id=5cc25de7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc25de7",
  null
  
)

export default component.exports